module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0060.jpg?v=c2d28227";